const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** Returns normalized YYYY-MM-DD, empty string, or null if invalid. */
export function parseIsoDate(value: string): string | null {
  const v = value.trim();
  if (!v) {
    return "";
  }
  if (!ISO_DATE.test(v)) {
    return null;
  }
  const [y, m, d] = v.split("-").map((part) => parseInt(part, 10));
  const dt = new Date(Date.UTC(y, m - 1, d));
  if (
    dt.getUTCFullYear() !== y ||
    dt.getUTCMonth() !== m - 1 ||
    dt.getUTCDate() !== d
  ) {
    return null;
  }
  return v;
}

export function isoDateToLocalDate(iso: string): Date | undefined {
  const normalized = parseIsoDate(iso);
  if (!normalized) {
    return undefined;
  }
  const [y, m, d] = normalized.split("-").map((part) => parseInt(part, 10));
  return new Date(y, m - 1, d);
}

export function localDateToIsoDate(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

/** Local calendar date for today (YYYY-MM-DD). */
export function localTodayIsoDate(): string {
  return localDateToIsoDate(new Date());
}

export function startOfLocalToday(): Date {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

/** Compare ISO dates (YYYY-MM-DD). Returns true if `iso` is after `maxIso`. */
export function isIsoDateAfter(iso: string, maxIso: string): boolean {
  const normalized = parseIsoDate(iso);
  const max = parseIsoDate(maxIso);
  if (!normalized || !max) return false;
  return normalized > max;
}

export function isoDateToUnixStart(iso: string): number | undefined {
  const normalized = parseIsoDate(iso);
  if (!normalized) return undefined;
  const [y, m, d] = normalized.split("-").map((part) => parseInt(part, 10));
  return Math.floor(Date.UTC(y, m - 1, d, 0, 0, 0, 0) / 1000);
}

export function isoDateToUnixEnd(iso: string): number | undefined {
  const normalized = parseIsoDate(iso);
  if (!normalized) return undefined;
  const [y, m, d] = normalized.split("-").map((part) => parseInt(part, 10));
  return Math.floor(Date.UTC(y, m - 1, d, 23, 59, 59, 999) / 1000);
}
